const API_URL = process.env.REACT_APP_API_URL + "/api/auth";

export async function createDemoUser() {
  const res = await fetch(`${API_URL}/demo`, {
    method: "POST",
    credentials: "include",
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to start demo");
  return data;
}
